export default {
  admin: [
    {
      icon: 'fa fa-file-alt',
      label: '客台資料管理',
      group: [
        {
          label: 'page.open-data.data',
          route: {
            name: 'admin.open-data-list',
            params: { category: 'data' },
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_OPENDATA'],
        },
        {
          label: 'page.open-data.service',
          route: {
            name: 'admin.open-data-list',
            params: { category: 'service' },
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_OPENDATA'],
        },

        {
          label: 'module.article',
          route: {
            name: 'admin.article-list',
            query: {
              page: 1,
              sort: 'created_at=desc',
            },
          },
          roles: ['ROLE_ADMIN', 'ROLE_OPENDATA'],
        },
      ],
    },
  ],
}